import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faEye } from '@fortawesome/free-solid-svg-icons';
import Circles from '../../../assets/images/circle.png';
import axios from 'axios';
import { SessionMonitor } from 'oidc-client';

const SurveyorLoginDashboard = ({ 
  loading, 
  crmDemoCount: crmDemoCountProp,
  handleMoreInfoClick 
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [localLoading, setLocalLoading] = useState(false);
  const [crmDemoCount, setCrmDemoCount] = useState(0);
  const [chcHistoryCount, setChcHistoryCount] = useState(0);
  const [expensiveCrmCount, setExpensiveCrmCount] = useState(0);
  const [expensiveSmamCount, setExpensiveSmamCount] = useState(0);
  const [IndividualCrmDemoCount, setIndividualCrmDemoCount] = useState(0);
  const [IndividualSmamDemoCount, setIndividualSmamDemoCount] = useState(0);
  const [crmDemoDetails, setCrmDemoDetails] = useState([]);
  const [chcDetails, setChcDetails] = useState([]);
  const [expensiveCrmDetails, setExpensiveCrmDetails] = useState([]);
  const [crmDemoVisible, setCrmDemoVisible] = useState(false);
  const [chcHistoryVisible, setChcHistoryVisible] = useState(false);
  const [expensiveCrmVisible, setExpensiveCrmVisible] = useState(false);
  const displayedCrmDemoCount = crmDemoCountProp ?? crmDemoCount;

  // Function to handle table visibility
  const handleTableVisibility = (table) => {
    if (table === 'crmDemo') {
      setCrmDemoVisible(true);
      setChcHistoryVisible(false);
      setExpensiveCrmVisible(false);
      fetchSurveyorCrmDemoCount(true);
    } else if (table === 'chcHistory') {
      setCrmDemoVisible(false);
      setChcHistoryVisible(true);
      setExpensiveCrmVisible(false);
    } else if (table === 'expensiveCrm') {
      setCrmDemoVisible(false);
      setChcHistoryVisible(false);
      setExpensiveCrmVisible(true);
      // Fetch Expensive Machinery list (schemeCode 2 for CRM)
      fetchExpensiveMachineryList(2);
    } else if (table === 'expensiveSmam') {
      setCrmDemoVisible(false);
      setChcHistoryVisible(false);
      setExpensiveCrmVisible(true);
      // Fetch Expensive Machinery list (schemeCode 3 for SMAM)
      fetchExpensiveMachineryList(3);
    }
  };

  // Helper function for CSV export - Farmer data
  const exportToCSV = (data, filename, headers) => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const csvRows = [headers.join(",")];

    data.forEach((item, index) => {
      const row = [
        index + 1,
        `"${item.farmerName || 'N/A'}"`,
        `"${item.mobileNo || 'N/A'}"`,
        `"${item.stateName || 'N/A'}"`,
        `"${item.districtName || 'N/A'}"`,
        `"${item.villageName || 'N/A'}"`
      ];
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Helper function for CSV export - CHC data
  const exportCHCToCSV = (data, filename) => {
    if (!data || data.length === 0) {
      alert("No CHC data available to export.");
      return;
    }

    const headers = ["S.No", "CHC Name", "Contact Person", "Mobile No", "State", "District", "Village"];
    const csvRows = [headers.join(",")];

    data.forEach((item, index) => {
      const row = [
        index + 1,
        `"${item.chcName || 'N/A'}"`,
        `"${item.contactPersonName || 'N/A'}"`,
        `"${item.mobileNo || 'N/A'}"`,
        `"${item.stateName || 'N/A'}"`,
        `"${item.districtName || 'N/A'}"`,
        `"${item.villageName || 'N/A'}"`
        
      ];
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
//alert(sessionStorage.getItem('userRoleCodeModel'));
  const fetchSurveyorCrmDemoCount = async (includeDetails = false) => {
    try {
        const createdBy = sessionStorage.getItem('userCodeModel');
      if (!createdBy) return;

      const { data } = await axios.post(
        `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Farmers/GetMTFarmerRegData`,
        { createdBy: parseInt(createdBy) },
        { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
      );

      if (data && data.success) {
        console.log('CRMDemoCount (count) Response:', data);
        const count = parseInt((data.recordCount ?? (Array.isArray(data.dataContent) ? data.dataContent.length : 0)).toString()) || 0;
        setCrmDemoCount(count);
        if (includeDetails) {
          setCrmDemoDetails(Array.isArray(data.dataContent) ? data.dataContent : []);
        }
      } else {
        setCrmDemoCount(0);
        if (includeDetails) {
          setCrmDemoDetails([]);
        }
      }
    } catch (e) {
      setCrmDemoCount(0);
      if (includeDetails) {
        setCrmDemoDetails([]);
      }
    }
  };

  // Fetch Expensive Machinery count for given schemeCode (2=CRM, 3=SMAM)
  const fetchExpensiveMachineryCount = async (schemeCode = 2) => {
    try {
        const createdBy = sessionStorage.getItem('userCodeModel');
      if (!createdBy) return;

      const { data } = await axios.post(
       `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/ExpensiveMachinery/GetExpSurvyorByID`,
        { flag: 'C', createdBy: parseInt(createdBy), schemeCode: parseInt(schemeCode) },
        { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
      );

      console.log('GetExpSurvyorByID (count) Response for schemeCode', schemeCode, ':', data);
      if (data && data.success) {
        const responseData = data.dataContent?.[0] ?? data;
        const crmCount = parseInt((data.expensiveCrm ?? responseData.expensiveCrm ?? 0).toString()) || 0;
        const smamCount = parseInt((data.expensiveSmam ?? responseData.expensiveSmam ?? 0).toString()) || 0;

        setExpensiveCrmCount(crmCount);
        setExpensiveSmamCount(smamCount);
        console.log('Extracted counts:', { crmCount, smamCount });
      } else {
        setExpensiveCrmCount(0);
        setExpensiveSmamCount(0);
      }
    } catch (e) {
      console.error('Error fetching Expensive Machinery count:', e);
      setExpensiveCrmCount(0);
      setExpensiveSmamCount(0);
    }
  };

  useEffect(() => {
    const navState = location.state;
    if (!navState?.restoreState) return;

    setCrmDemoVisible(Boolean(navState.crmDemoVisible));
    setChcHistoryVisible(Boolean(navState.chcHistoryVisible));
    setExpensiveCrmVisible(Boolean(navState.expensiveCrmVisible));

    if (Array.isArray(navState.crmDemoDetails)) {
      setCrmDemoDetails(navState.crmDemoDetails);
      setCrmDemoCount(navState.crmDemoDetails.length);
    }

    if (Array.isArray(navState.chcDetails)) {
      setChcDetails(navState.chcDetails);
      setChcHistoryCount(navState.chcDetails.length);
    }

    if (Array.isArray(navState.expensiveCrmDetails)) {
      setExpensiveCrmDetails(navState.expensiveCrmDetails);
      setExpensiveCrmCount(navState.expensiveCrmDetails.length);
    }
  }, [location.state]);

  // Fetch Expensive Machinery survey list for given schemeCode (2=CRM, 3=SMAM)
  const fetchExpensiveMachineryList = async (schemeCode = 2) => {
    try {
      const createdBy = sessionStorage.getItem('userCodeModel');
      if (!createdBy) return;

      const { data } = await axios.post(
        `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/ExpensiveMachinery/GetExpSurvyorByID`,
        { flag: 'D', createdBy: parseInt(createdBy), schemeCode: parseInt(schemeCode) },
        { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
      );

      console.log('GetExpSurvyorByID (list) Response for schemeCode', schemeCode, ':', data);
      if (data && data.success && Array.isArray(data.dataContent)) {
        setExpensiveCrmDetails(data.dataContent);
        const count = data.dataContent.length;
        if (parseInt(schemeCode) === 3) {
          setExpensiveSmamCount(data.expensiveSmam ?? count);
        } else {
          setExpensiveCrmCount(data.expensiveCrm ?? count);
        }
      } else {
        setExpensiveCrmDetails([]);
      }
    } catch (err) {
      console.error('Error fetching Expensive Machinery survey list:', err);
      setExpensiveCrmDetails([]);
    }
  };
  //   try {
  //     const createdBy = sessionStorage.getItem('userCodeModel');
  //     if (!createdBy) return;

  //     const { data } = await axios.post(
  //       `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/ExpensiveMachinery/GetExpSurvyorByID`,
  //       { flag: 'D', createdBy: parseInt(createdBy), schemeCode: parseInt(schemeCode) },
  //       { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
  //     );

  //     console.log('GetExpSurvyorByID (list) Response:', data);
  //     if (data && data.success && Array.isArray(data.dataContent)) {
  //       // For CRM (schemeCode 2) populate crmDemoDetails
  //       if (schemeCode === 2) {
  //         setCrmDemoDetails(data.dataContent);
  //         setCrmDemoCount(data.recordCount ?? data.dataContent.length ?? 0);
  //       } else if (schemeCode === 3) {
  //         // If needed later, can store SMAM list separately
  //         setCrmDemoDetails(data.dataContent);
  //         setCrmDemoCount(data.recordCount ?? data.dataContent.length ?? 0);
  //       }
  //     } else {
  //       setCrmDemoDetails([]);
  //     }
  //   } catch (err) {
  //     console.error('Error fetching Expensive Machinery survey list:', err);
  //     setCrmDemoDetails([]);
  //   }
  // };

  const fetchSurveyorChcCount = async () => {
    try {
      const surveyorUserCode = sessionStorage.getItem('userCodeModel');
      
      if (!surveyorUserCode) {
        console.log('No surveyorUserCode found in session storage');
        return setChcHistoryCount(0);
      }
      
      console.log('Fetching CHC details for surveyor:', surveyorUserCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Get_CHCDetailByID`,
        { 
          "surveyorUserCode": parseInt(surveyorUserCode)
        },
        { headers: { accept: '*/*', 'Content-Type': 'application/json' } }
      );
      
      console.log('CHC Details API Response:', data);
      
      if (data && data.success && data.dataContent && data.dataContent.length > 0) {
        // Log the full response for debugging
        console.log('Full CHC response data:', JSON.stringify(data.dataContent[0], null, 2));
        
        // Set the count from the first item's recordCount
        const count = data.dataContent.length;
        console.log('Setting CHC count to:', count);
        setChcHistoryCount(count);
        
        // Store the full details for the table
        setChcDetails(data.dataContent);
        console.log('CHC details set:', data.dataContent);
      } else {
        console.log('No CHC data received or invalid format');
        setChcHistoryCount(0);
        setChcDetails([]);
      }
    } catch (e) {
      console.error('Error fetching Surveyor CHC count:', e);
      setChcHistoryCount(0);
      setChcDetails([]);
    }
  };

  const fetchSurveyorIndCount = async () => {
    try {
      const surveyorUserCode = sessionStorage.getItem('userCodeModel');
      
      if (!surveyorUserCode) {
        console.log('No surveyorUserCode found in session storage');
        return setChcHistoryCount(0);
      }
      
      console.log('Fetching CHC details for surveyor:', surveyorUserCode);
      
      const { data } = await axios.post(
        `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Get_CHCDetailByID`,
        { 
          "surveyorUserCode": parseInt(surveyorUserCode)
        },
        { headers: { accept: '*/*', 'Content-Type': 'application/json' } }
      );
      
      console.log('CHC Details API Response:', data);
      
      if (data && data.success && data.dataContent && data.dataContent.length > 0) {
        // Log the full response for debugging
        console.log('Full CHC response data:', JSON.stringify(data.dataContent[0], null, 2));
        
        // Set the count from the first item's recordCount
        const count = data.dataContent.length;
        console.log('Setting CHC count to:', count);
        setChcHistoryCount(count);
        
        // Store the full details for the table
        setChcDetails(data.dataContent);
        console.log('CHC details set:', data.dataContent);
      } else {
        console.log('No CHC data received or invalid format');
        setChcHistoryCount(0);
        setChcDetails([]);
      }
    } catch (e) {
      console.error('Error fetching Surveyor CHC count:', e);
      setChcHistoryCount(0);
      setChcDetails([]);
    }
  };

  useEffect(() => {
    let isMounted = true;
    (async () => {
      setLocalLoading(true);
      try {
        // Avoid duplicate GetExpSurvyorByID call on initial load.
        await Promise.all([fetchSurveyorChcCount(), fetchSurveyorCrmDemoCount(), fetchExpensiveMachineryCount(2)]);
      } finally {
        if (isMounted) setLocalLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, []);
  return (
    <div className="row">
      {/* Machine Demonstration (CRM) Card */}
      <div className="col-xxl-6 col-xl-6">
        <div className="card info-card sales-card bg-gradient-danger card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Machine Demonstration (CRM)</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="recordCount">{loading || localLoading ? 'Loading...' : displayedCrmDemoCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleTableVisibility('crmDemo')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Established CHC Card */}
      {sessionStorage.getItem('userRoleCodeModel')==="5" && (
      <div className="col-xxl-6 col-xl-6">
        <div className="card info-card sales-card bg-gradient-primary card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Established CHC </h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="recordCount">{loading || localLoading ? 'Loading...' : chcHistoryCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleTableVisibility('chcHistory')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
)}
 <div className="col-xxl-6 col-xl-6">
        <div className="card info-card sales-card bg-gradient-lite card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Individual Crm Survey </h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="expensiveCrm">{loading || localLoading ? 'Loading...' : expensiveCrmCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleTableVisibility('expensiveCrm')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-6 col-xl-6">
        <div className="card info-card sales-card bg-gradient-primary card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Individual Smam Survey </h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="expensiveSmam">{loading || localLoading ? 'Loading...' : expensiveSmamCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleTableVisibility('expensiveSmam')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Machine Demonstration Details Table */}
      {crmDemoVisible && (
        <div className="col-12">
          <h5>Machine Demonstration (CRM) - Farmer Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(crmDemoDetails, "MT_CRM_Demo_Farmer_Report", ["S.No", "Farmer Name", "Mobile No", "State", "District", "Village"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>Farmer Name</th>
                  <th>Mobile No</th>
                  <th>State</th>
                  <th>District</th>
                  <th>Village</th>
                  <th>View Details</th>
                </tr>
              </thead>
              <tbody>
                {crmDemoDetails && crmDemoDetails.length > 0 ? (
                  crmDemoDetails.map((farmer, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{farmer.farmerName}</td>
                      <td>{farmer.mobileNo}</td>
                      <td>{farmer.stateName}</td>
                      <td>{farmer.districtName}</td>
                      <td>{farmer.villageName}</td>
                      <td>
                        <button 
                          className="btn" 
                          type="button" 
                          onClick={() => {
                            console.log('Farmer data:', farmer);
                            const farmerCode = farmer.farmerCode;
                            console.log('Using farmer code:', farmerCode);
                            // Create farmer details object with all available data
                            const farmerDetails = {
                              farmerCode: farmer.farmerCode,
                              farmerName: farmer.farmerName,
                              stateName: farmer.stateName,
                              districtName: farmer.districtName,
                              villageName: farmer.villageName,
                              mobileNo: farmer.mobileNo,
                              totalAreaInHA: farmer.totalAreaInHA,
                              aadharNo: farmer.aadharNo,
                              farmerId: farmer.farmerId
                            };
                            // Navigate to the Surveyor Detail View page with all farmer details
                            navigate("/MNT/SurveyorDetailView", { 
                              state: { 
                                farmerData: farmerDetails,
                                returnTo: "/MNT/dashboardMnT",
                                crmDemoVisible,
                                chcHistoryVisible,
                                crmDemoDetails,
                                chcDetails
                              } 
                            });
                          }}
                        >
                          <i><FontAwesomeIcon icon={faEye} /></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">No farmer data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Expensive Machinery Details Table */}
      {expensiveCrmVisible && (
        <div className="col-12">
          <h5>Individual Survey - Expensive Machinery Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportToCSV(expensiveCrmDetails, "MT_Expensive_Machinery_Report", ["S.No", "Farmer Name", "Mobile No", "State", "District", "Village"])}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>Farmer Name</th>
                  <th>Mobile No</th>
                  <th>State</th>
                  <th>District</th>
                  <th>Village</th>
                  <th>View Details</th>
                </tr>
              </thead>
              <tbody>
                {expensiveCrmDetails && expensiveCrmDetails.length > 0 ? (
                  expensiveCrmDetails.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.farmerName ||'N/A'}</td>
                      <td>{item.mobileNo || item.mobileNumber || 'N/A'}</td>
                      <td>{item.stateName || 'N/A'}</td>
                      <td>{item.districtName || 'N/A'}</td>
                      <td>{item.villageName || 'N/A'}</td>
                      <td>
                        <button 
                          className="btn btn-primary" 
                          type="button" 
                          onClick={async () => {
                            console.log('Expensive Machinery item data:', item);
                            
                            // Try to detect beneficiary ID from row
                            const keys = Object.keys(item || {});
                            
                            // Check direct ID fields first - all possible variations
                            let beneficiaryId = 
                              item?.beneficiaryId ??
                              item?.beneficiaryID ??
                              item?.beneficiaryid ??
                              item?.beneficiary_id ??
                              item?.BeneficiaryId ??
                              item?.beneficiaryCode ??
                              item?.beneficiarycode ??
                              item?.id ??
                              item?.Id ??
                              item?.farmerId ??
                              item?.farmerID;

                            // If not found, search dynamically for beneficiary-like fields
                            if (!beneficiaryId) {
                              const matchedKey = keys.find((k) => {
                                const key = String(k).toLowerCase();
                                const hasBeneficiary = key.includes('beneficiary') || key.includes('ben');
                                const hasIdOrCode = key.includes('id') || key.includes('code');
                                return hasBeneficiary && hasIdOrCode;
                              });
                              if (matchedKey) {
                                beneficiaryId = item[matchedKey];
                              }
                            }

                            const trimmedId = beneficiaryId !== undefined && beneficiaryId !== null
                              ? String(beneficiaryId).trim()
                              : '';
                            
                            console.log('Detected ID:', { beneficiaryId, trimmedId, keys: keys.slice(0, 5) });

                            // If no ID found, navigate with row data directly (like CRM Demo table)
                            if (!trimmedId) {
                              console.log('No beneficiaryId found, navigating with row data:', item);
                              navigate("/MNT/SurveyorDetailView", { 
                                state: { 
                                  farmerData: item,
                                  returnTo: "/MNT/dashboardMnT",
                                  expensiveCrmVisible,
                                  expensiveCrmDetails
                                } 
                              });
                              return;
                            }

                            // If ID found, fetch details via API
                            try {
                              const { data } = await axios.post(
                                `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/ExpensiveMachinery/GetExpBenDataByBenID`,
                                { beneficiaryId: trimmedId },
                                { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
                              );

                              const beneficiaryData = Array.isArray(data?.dataContent)
                                ? data.dataContent[0]
                                : data?.dataContent;

                              navigate("/MNT/SurveyorDetailView", { 
                                state: { 
                                  farmerData: beneficiaryData || item,
                                  returnTo: "/MNT/dashboardMnT",
                                  expensiveCrmVisible,
                                  expensiveCrmDetails
                                } 
                              });
                            } catch (error) {
                              console.error('Error fetching beneficiary details:', error);
                              // Fallback: navigate with row data if API fails
                              navigate("/MNT/SurveyorDetailView", { 
                                state: { 
                                  farmerData: item,
                                  returnTo: "/MNT/dashboardMnT",
                                  expensiveCrmVisible,
                                  expensiveCrmDetails
                                } 
                              });
                            }
                          }}
                        >
                          <i><FontAwesomeIcon icon={faEye} /></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">No expensive machinery data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* CHC History Details Table */}
      {chcHistoryVisible && (
        <div className="col-12">
          <h5>CHC History Details</h5>
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn btn-success" 
              onClick={() => exportCHCToCSV(chcDetails, "CHC_History_Report")}
            >
              Export CSV
            </button>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr className="table-light">
                  <th>Sr. No.</th>
                  <th>CHC Name</th>
                  <th>Contact Person</th>
                  <th>Mobile No</th>
                  <th>State</th>
                  <th>District</th>
                  <th>Village</th>
                  <th>View Details</th>
                </tr>
              </thead>
              <tbody>
                {chcDetails && chcDetails.length > 0 ? (
                  chcDetails.map((chc, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{chc.chcName || 'N/A'}</td>
                      <td>{chc.contactPersonName || 'N/A'}</td>
                      <td>{chc.mobileNo || 'N/A'}</td>
                      <td>{chc.stateName || 'N/A'}</td>
                      <td>{chc.districtName || 'N/A'}</td>
                      <td>{chc.villageName || 'N/A'}</td>
                      <td>
                        <button 
                          className={`btn ${chc && chc.chcId ? 'btn-primary' : 'btn-secondary'}`}
                          type="button" 
                          onClick={() => {
                            console.log('CHC data:', chc);
                            
                            // Validate CHC data before navigation
                            if (!chc || !chc.chcId) {
                              alert('CHC data is not available or incomplete. Please try again.');
                              console.error('❌ Invalid CHC data:', chc);
                              return;
                            }
                            
                            const chcId = chc.chcId;
                            console.log('✅ Using CHC ID:', chcId);
                            
                            // Navigate to the CHC Detail View page with the selected CHC ID and farmerCode
                            navigate("/MNT/CHCDetailView", { 
                              state: { 
                                chcId,
                                farmerData: { farmerCode: chc.farmerCode || chc.chcId.toString() },
                                returnTo: "/MNT/dashboardMnT",
                                chcHistoryVisible,
                                chcDetails,
                                crmDemoVisible,
                                crmDemoDetails,
                                expensiveCrmVisible,
                                expensiveCrmDetails,
                              } 
                            });
                          }}
                          title={chc && chc.chcId ? "View CHC Details" : "CHC data not available"}
                          disabled={!chc || !chc.chcId}
                        >
                          <i><FontAwesomeIcon icon={faEye} /></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">No CHC history data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurveyorLoginDashboard;
